import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const serviceNowSelector = (state: RootState) => state?.serviceNow;

export const serviceNowSendingSelector = createSelector(
  serviceNowSelector,
  serviceNow => serviceNow?.isSendingIncident
);

export const serviceNowDataSelector = createSelector(
  serviceNowSelector,
  serviceNow => serviceNow?.incidentData
);

export const serviceNowErrorSelector = createSelector(
  serviceNowSelector,
  serviceNow => serviceNow?.incidentError
);
